import { HttpMethod } from './interfaces';

export const HTTP_METHODS = {
  DELETE: 'DELETE' as HttpMethod,
  GET: 'GET' as HttpMethod,
  POST: 'POST' as HttpMethod,
  PUT: 'PUT' as HttpMethod,
};
